import React from 'react';
import { makeStyles } from '@mui/styles';
import { Typography } from '@mui/material';
import { appInsights } from '../../../auth/appInsight';
import { getStringProduct } from '../../../utils/utilityFunctions';

const useStyles = makeStyles((theme, props) => ({
  root: {
    fontFamily: 'Poppins',
    fontSize: '24px !important',
    fontWeight: 500,
    lineHeight: '36px',
    color: theme.palette.text.primary,
    ...props,
    [theme.breakpoints.up('xll')]: {
      fontSize: `${getStringProduct(1.25, '24px')}!important`,
      lineHeight: getStringProduct(1.25, '36px'),
    }, 
    [theme.breakpoints.up('xlll')]: {
      fontSize: `${getStringProduct(1.66, '24px')}!important`,
      lineHeight: getStringProduct(1.66, '36px'),
    }, 
    [theme.breakpoints.up('xl4')]: {
      fontSize: `${getStringProduct(2.46, '24px')}!important`,
      lineHeight: getStringProduct(2.46, '36px'),
    }, 
    // fontFamily: "Montserrat"
    // backgroundColor: theme.palette.primary.main,
  }
}));
export const FreedomTypography = (props) => {
  const classes = useStyles();
  const { children } = props;
  try {
    return (
      <Typography className={classes.root} {...props}>
        {' '}
        {children}
      </Typography>
    );
  } catch (error) {
    appInsights.trackException({ error: new Error(error) });
  }
};
